import tw, { styled } from "twin.macro"

export const Title = styled.h2`
  ${tw`text-2xl tracking-wider uppercase font-display lg:text-4xl`}
`
